/*
 * @Author: liukai
 * @since: 2022-04-26 15:14:29
 * @LastAuthor: liukai
 * @lastTime: 2022-04-26 16:12:47
 */

    let sensors = window['sensorsDataAnalytic201505']
    sensors.init({
        show_log: false,
        name: 'sensors',
        server_url: `${process.env.VUE_APP_TRACK_URL}/behavior/sa?token=27f1e21b78daf376&project=hntv&clientId=bd4859dcd7b141eeb297e2f6b6333cec`,
        app_js_bridge: false,
        heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'default',
        collect_url: true,
        collect_input: false,
        element_selector: 'not_use_id',
        },
    })
    sensors.quick('autoTrack')

const gzTrack=(articleId)=>{
    sensors.track('ViewH5', {h5Project:'gzShare',domainName:'https://static.hntv.tv',articleId:articleId})
}
export default gzTrack;